import { useMerchantRisks } from "@/api/admin/merchant-risks";

type SafetyModelCount = { total: number; hasCustom: boolean };

export const useSafetyModelCount = (merchantId: string): SafetyModelCount => {
  const { data } = useMerchantRisks(merchantId);

  return {
    total: data?.length ?? 0,
    hasCustom: data?.some((risk) => risk.risk.category === "custom") ?? false,
  };
};
